import config from '../config';
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../helpers';

const endpointPath = config.api.API_URL + '/custom_property_object_map';

export const customPropertyObjectMapService = {
  getByCustomPropertyId,
};

function getByCustomPropertyId(id, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/custom_property_id/${id}`, requestOptions, signal).then(
    handleResponse
  );
}
